export const INSTRUCTOR_IMAGES: Record<string, string> = {
  markCuban: 'https://static.masterclass.com/mcx_mark_cuban.png',
  tonyRobbins: 'https://static.masterclass.com/mcx_tony_robbins.png',
  matiStaniszewski: 'https://static.masterclass.com/mcx_mati_staniszewski.png',
  indraNooyi: 'https://static.masterclass.com/mcx_indra_nooyi.png',
  grantLee: 'https://static.masterclass.com/mcx_grant_lee.png',
  garyVaynerchuk: 'https://static.masterclass.com/mcx_gary_vee.png',
  issaRae: 'https://static.masterclass.com/mcx_issa_rae.png',
  rayDalio: 'https://static.masterclass.com/mcx_ray_dalio.png',
  paulKrugman: 'https://static.masterclass.com/mcx_paul_krugman.png',
  kevinMayer: 'https://static.masterclass.com/mcx_kevin_mayer.png',
  maureenChiquet: 'https://static.masterclass.com/mcx_maureen_chiquet.png',
  sanjogMisra: 'https://static.masterclass.com/mcx_sanjog_misra.png',
  jackDongarra: 'https://static.masterclass.com/mcx_jack_dongarra.png',
  dambisaMoyo: 'https://static.masterclass.com/mcx_dambisa_moyo.png',
  alexImas: 'https://static.masterclass.com/mcx_alex_imas.png',
  eugeneFama: 'https://static.masterclass.com/mcx_eugene_fama.png',
  douglasDiamond: 'https://static.masterclass.com/mcx_douglas_diamond.png',
  lindaYueh: 'https://static.masterclass.com/mcx_linda_yueh.png',
  anilKashyap: 'https://static.masterclass.com/mcx_anil_kaship.png',
  madhavRajan: 'https://static.masterclass.com/mcx_madhav.png',
  stevenKaplan: 'https://static.masterclass.com/mcx_steven_kaplan.png',
  jeanPierreDube: 'https://static.masterclass.com/mcx_jp_dube.png',
  bobSutton: 'https://static.masterclass.com/mcx_bob_sutton.png',
  jerryDischler: 'https://static.masterclass.com/mcx_jerry_dischler.png',
  michaelBungayStanier:
    'https://static.masterclass.com/mcx_michael_bungay_stanier.png',
  ayeletFishbach: 'https://static.masterclass.com/mcx_ayelet_fishbach.png',
  nicholasEpley: 'https://static.masterclass.com/mcx_nicholas_epley.png',
  margaretAnnNeale: 'https://static.masterclass.com/mcx_margaret_neale.png',
  halHershfield: 'https://static.masterclass.com/mcx_hal_h.png',
}
